module.exports = __webpack_public_path__ + "img/cover-sirius.a1f5d47b.png";